import {Record} from "immutable";
import {
    onAppAllowSound,
    onOrderActionClick,
    onOrderActionClickFail,
    onOrderActionClickSuccess,
    onOrderLoadDetails,
    onOrderLoadDetailsFail,
    onOrderLoadDetailsSuccess, onOrderRemovePendingByOrderId,
    onOrdersChangeType,
    onOrdersClearPending,
    onOrdersClearUpdates,
    onOrdersCloseOrder,
    onOrdersLoad,
    onOrdersLoadFail,
    onOrdersLoadSuccess,
    onOrdersPendingLoad,
    onOrdersPendingLoadFail,
    onOrdersPendingLoadSuccess,
    onOrdersRemovePending,
    onOrdersRemoveUpdates,
    onOrdersShowOrder,
    onOrdersShowOrderUpdates,
    onOrdersUpdateAttribute,
    onOrdersUpdatesLoad,
    onOrdersUpdatesLoadFail,
    onOrdersUpdatesLoadSuccess,
    onOrderUpdateRefundReason,
    onOrderUpdateRefundReasonAmount,
    onOrderUpdateRefundReasonText,
    onOrderVisibleRefundReason,
    onUpdateOnlyFood
} from "./actions";

export const REFUND_REASON_DUBLICATE = 'dublicate';
export const REFUND_REASON_FRAUDULENT = 'fraudulent';
export const REFUND_REASON_CUSTOMER = 'customer';
export const REFUND_REASON_OTHER = 'other';

export const TYPE_LIVEORDERS = 'liveorders'
export const TYPE_COMPLETED = 'completed'

export const ORDER_STATUS = 'confirmed'

export const ORDER_TYPE_DINEIN = 'dinein'
export const ORDER_TYPE_PICKUP = 'pickup'

const orders = new Record({
    loading: false,
    type: 'liveorders',
    name: '',
    orderId: '',
    orders: {
        data: [],
        current_page: null,
        per_page: null,
        total: null,
        links: null
    },
    restaurant: '',
    restaurants: [],
    tag: '',
    tags: [],
    orderPending: [],
    orderUpdates: [],

    order: {},
    order_loading: false,
    showOrder: false,

    allowSound: false,

    onlyFood: false,
    refundVisible: false,
    refundReason: '',
    refundReasonText: '',
    refundReasonAmount: '',
})();

export default (state = orders, action) => {
    switch (action.type) {
        case onOrdersPendingLoad().type:
            return state.set('loading', true)
                .set('orderPending', [...state.orderPending, action.order]);
        case onOrdersUpdatesLoad().type:
            return state.set('loading', true)
                .set('orderUpdates', [...state.orderUpdates, action.order]);

        case onOrdersPendingLoadSuccess().type:
        case onOrdersPendingLoadFail().type:
        case onOrdersUpdatesLoadSuccess().type:
        case onOrdersUpdatesLoadFail().type:
            return state.set('loading', false);

        case onOrdersClearPending().type:
            return state.set('orderPending', []);
        case onOrdersClearUpdates().type:
            return state.set('orderUpdates', []);

        case onOrdersLoad().type:
            return state.set('loading', true);
        case onOrdersLoadFail().type:
            return state.set('loading', false);

        case onOrdersLoadSuccess().type:
            return state.set('type', action.data.type)
                .set('loading', false)
                .set('name', action.data.name)
                .set('orderId', action.data.orderId)
                .set('orders', action.data.orders)
                .set('restaurant', action.data.restaurant)
                .set('restaurants', action.data.restaurants)
                .set('tags', action.data.tags);

        case onOrdersChangeType().type:
            return state.set('type', action.value)

        case onOrdersUpdateAttribute().type:
            return state.set(`${action.name}`, action.value)

        case onOrdersShowOrder().type: {
            const items = state.get('orderPending')
            const newItems = items.filter((_, i) => i !== action.index);
            return state.set('showOrder', true)
                .set('order', action.order)
                .set('orderPending', newItems);
        }
        case onOrdersShowOrderUpdates().type: {
            const items = state.get('orderUpdates')
            const newItems = items.filter((_, i) => i !== action.index);
            return state.set('showOrder', true)
                .set('order', action.order)
                .set('orderUpdates', newItems);
        }
        case onOrdersCloseOrder().type: {
            return state.set('showOrder', false)
                .set('order', {});
        }
        case onOrdersRemovePending().type: {
            const items = state.get('orderPending')
            const newItems = items.filter((_, i) => i !== action.index);
            return state.set('orderPending', newItems);
        }
        case onOrdersRemoveUpdates().type: {
            const items = state.get('orderUpdates')
            const newItems = items.filter((_, i) => i !== action.index);
            return state.set('orderUpdates', newItems);
        }
        case onOrderRemovePendingByOrderId().type: {
            const itemsPending = state.get('orderPending')
            const newItemsPending = itemsPending.filter((item, _) => item.id !== action.orderId);

            const itemsUpdates = state.get('orderUpdates')
            const newItemsUpdates = itemsUpdates.filter((item, _) => item.id !== action.orderId);

            return state
                .set('orderPending', newItemsPending)
                .set('orderUpdates', newItemsUpdates);
        }

        case onOrderLoadDetails().type:
            return state.set('order_loading', true)
        case onOrderLoadDetailsSuccess().type:
            return state.set('order', action.data.order)
                .set('order_loading', false);
        case onOrderLoadDetailsFail().type:
            return state.set('order_loading', false)

        case onOrderActionClick().type:
            return state.set('order_loading', true)
        case onOrderActionClickSuccess().type: {
            if (action.data.order.status === 'completed') {
                return state.set('order_loading', false)
                    .set('refundReason', '')
                    .set('refundReasonText', '')
                    .set('refundReasonAmount', '')
                    .set('order', {});
            } else {
                const index = state.getIn(['orders', 'data']).findIndex(item => item.id === action.data.order.id);
                return state.set('order_loading', false)
                    .set('order', action.data.order)
                    .set('refundReason', '')
                    .set('refundReasonText', '')
                    .set('refundReasonAmount', '')
                    .setIn(['orders', 'data', index, 'status'], action.data.order.status)
            }

        }

        case onOrderActionClickFail().type:
            return state.set('order_loading', false)

        case onAppAllowSound().type:
            return state.set('allowSound', true)

        case onUpdateOnlyFood().type:
            return state.set('onlyFood', !state.get('onlyFood'))

        case onOrderUpdateRefundReason().type:
            return state.set('refundReason', action.reason)
        case onOrderUpdateRefundReasonAmount().type:
            return state.set('refundReasonAmount', action.amount)
        case onOrderUpdateRefundReasonText().type:
            return state.set('refundReasonText', action.text)
        case onOrderVisibleRefundReason().type:
            return state.set('refundVisible', action.show)
                .set('refundReason', '')
                .set('refundReasonText', '')
        default:
            return state;
    }
}
